import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    resources: {
      en: {
        translation: {
          welcome: "Welcome to iDisKover",
          login: "Login to Your Account",
          contact: "Contact Us",
        },
      },
      fr: {
        translation: {
          welcome: "Bienvenue sur iDisKover",
          login: "Connectez-vous à votre compte",
          contact: "Contactez-nous",
        },
      },
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
